export default function SVGComputer(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M39 43H25V55H39V43Z" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 35H57" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19 55H45" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="6" y="43" width="35" height="52" rx="2" transform="rotate(-90 6 43)" stroke="#757575" strokeWidth="2" />
        </svg>
    );
}
